import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import {
  BarChart3,
  Eye,
  Upload,
  Truck,
  Database,
  Settings,
  Shield,
  Home,
  Factory
} from 'lucide-react';

export interface NavigationItem {
  path: string;
  label: string;
  icon: React.ComponentType<any>;
  id: string;
}

// Hook personalizado para obtener elementos de navegación filtrados
export function useNavigationItems(): NavigationItem[] {
  const { isDataManager, isSlaughterhouseUser } = useAuth();

  // Navegación completa
  const allNavigationItems: NavigationItem[] = [
    { path: '/dashboard', label: 'Dashboard', icon: BarChart3, id: 'dashboard' },
    { path: '/animals', label: isSlaughterhouseUser ? 'Consulta' : 'Visualización', icon: Eye, id: 'animals' },
    { path: '/certification', label: 'Certificación', icon: Shield, id: 'certification' },
    { path: '/imports', label: 'Importar', icon: Upload, id: 'imports' },
    { path: '/mobilizations', label: 'Movilizaciones', icon: Truck, id: 'mobilizations' },
    { path: '/ranches', label: 'Fincas', icon: Home, id: 'ranches' },
    { path: '/slaughterhouses', label: 'Plantas', icon: Factory, id: 'slaughterhouses' },
    { path: '/data-tables', label: 'Tablas', icon: Database, id: 'data-tables' },
    { path: '/users', label: 'Usuarios', icon: Settings, id: 'users' },
  ];

  // Filtrar según rol del usuario
  return allNavigationItems.filter(item => {
    // Slaughterhouse users: solo Certificación (story 1-6: view summary/tracking of a given animal DIN)
    if (isSlaughterhouseUser) {
      return ['certification'].includes(item.id);
    }

    // Data managers: acceso completo excepto certificación y usuarios (usuarios va en dropdown)
    if (isDataManager) {
      return !['certification', 'users'].includes(item.id);
    }

    // Fallback: solo dashboard, animals, ranches y slaughterhouses
    return ['dashboard', 'animals', 'ranches', 'slaughterhouses'].includes(item.id);
  });
}

// Componente Navigation para el Header
export default function Navigation() {
  const navigationItems = useNavigationItems();
  const location = useLocation();

  return (
    <nav className="nav-pills">
      {navigationItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        
        return (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-pill ${isActive ? 'active' : ''}`}
          >
            <Icon size={16} />
            <span>{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}